import React, {useEffect, useState} from "react";

import Button from "@mui/material/Button/Button.js";
import Dialog from "@mui/material/Dialog/Dialog.js";
import DialogActions from "@mui/material/DialogActions/DialogActions.js";
import DialogContent from "@mui/material/DialogContent/DialogContent.js";
import DialogTitle from "@mui/material/DialogTitle/DialogTitle.js";
import {useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {Grid, Box} from "@mui/material";
import EmailInput from "../elements/EmailInput.js";
import TextInput from "../elements/TextInput.js";
import {Link} from "react-router-dom";
import {enqueueSnackbar} from "../../redux/Actions.js";
import {removeCookie} from "weed-js";
import SubmitButton from "../elements/SubmitButton.js";
import {
    fetchOrganizations,
    fetchOrganizationUserGroupsForUser,
    fetchOrganizationUsers,
    fetchUserProfile,
    login,
    userLoggedIn
} from "../../redux/user/Action.js";
import Loading from "../elements/Loading.js";


const Login = ({
    setMainMenuAccordionExpanded,
    loggedInUser,
    userProfile,
    setLoggedInUser,
    setUserProfile,
    organizations,
    setOrganizations
}) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formState, setFormState] = useState({
        email: "",
        password: ""
    });
    const [errors, setErrors] = useState({
        email: "",
        password: ""
    });

    const [hideCreatePaidAccount, setHideCreatePaidAccount] = useState(false);

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const handleClickOpen = () => {
        removeCookie("sso");
        removeCookie("sso.csrf");
        removeCookie("sso.session");
        removeCookie("integration");
        removeCookie("organizationId");
        removeCookie("integrationAccountIds");
        setMainMenuAccordionExpanded(false);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleLogin = (click) => {
        setLoading(true);
        click.preventDefault();
        const abortController = new AbortController();
        dispatch(login(formState.email, formState.password)).then((currentUser) => {
            return Promise.all([
                dispatch(fetchUserProfile(currentUser, abortController)),
                dispatch(fetchOrganizationUserGroupsForUser(currentUser, abortController)),
                dispatch(fetchOrganizationUsers(null, currentUser.id, abortController)),
                dispatch(fetchOrganizations(null, abortController))
            ]).then(response => {
                const [fetchedUserProfile, fetchedOrganizationUserGroups, fetchedOrganizationUsers, fetchedOrganizations] = response;
                dispatch(userLoggedIn({
                    user: currentUser,
                    organizationUsers: fetchedOrganizationUsers,
                    organizations: fetchedOrganizations,
                    organizationUserGroups: fetchedOrganizationUserGroups,
                    profile: fetchedUserProfile,
                }));
                setLoading(false);
                handleClose();
                navigate(window.location.pathname + window.location.search);
            }).catch((err1) => {
                console.error("Got errors (1)", err1);
            });
        }).catch((errs) => {
            console.error("Got errors (2)", errs);
            setLoading(false);
            dispatch(enqueueSnackbar({
                message: "Login failed. Check your email and password and try again.",
                options: {
                    variant: "error",
                },
            }));
            if (errs && errs.data) {
                setErrors({...errors, ...errs.data});
            } else {
                setErrors({...errors, email: "Login failed. Check your email and password and try again."});
            }
        });
    };

    const onKeyPress = (event) => {
        if (!open) {
            return;
        }
        if (event.keyCode === 13) {
            handleLogin(event);
        }
    };

    useEffect(() => {
        window.addEventListener("keypress", onKeyPress);
        return () => {
            window.removeEventListener("keypress", onKeyPress);
        };
    });


    if (open) {
        return <>
            <Dialog 
                open={open} 
                onClose={handleClose} 
                className={"login-dialog"}
            >
                <DialogTitle>Log in</DialogTitle>
                <DialogContent className={"login-form" + (open ? " open-login-form" : "")}>
                    <form onSubmit={handleLogin}>
                        {loading ? <Loading fullscreen={false} title={"Let's get to it! Logging you in..."}/> :
                            <>
                                <EmailInput
                                    className={loading ? "hidden" : ""}
                                    name="email"
                                    label="Email Address"
                                    formState={formState}
                                    errors={errors}
                                    setFormState={setFormState}
                                    setErrors={setErrors}/>
                                <TextInput
                                    className={loading ? "hidden" : ""}
                                    setErrors={setErrors}
                                    type="password"
                                    name="password"
                                    label="Password"
                                    formState={formState}
                                    errors={errors}
                                    setFormState={setFormState}/>
                            </>
                        }
                    </form>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={12}>
                        <Grid xs={5} item>
                            <Link onClick={() => {
                                setOpen(false);
                            }} to="/forgot-password">Forgot Password</Link>
                        </Grid>
                        <Grid xs={7} item style={{display: "flex"}} className="actions" justifyContent="right" justifyItems="center" alignContent="center" alignItems="center">
                            {/*<CreatePaidAccount*/}
                            {/*    hideModal={hideCreatePaidAccount}*/}
                            {/*    setHideModal={setHideCreatePaidAccount}*/}
                            {/*    setLoggedInUser={setLoggedInUser}*/}
                            {/*    setUserProfile={setUserProfile}*/}
                            {/*    organizations={organizations}*/}
                            {/*    setOrganizations={setOrganizations}*/}
                            {/*/>*/}
                            <SubmitButton displayName="Login" onSubmit={handleLogin}>Login</SubmitButton>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>;
    }
    return <Box className="menu-item">
        <Button id="login-button" variant="outlined" onClick={handleClickOpen} className="open-dialog">
            Log in
        </Button>
    </Box>;
};


export default Login;
